module.exports = __webpack_public_path__ + "static/media/line-dotted.ae4b6c67.svg";